import logo from './logo.svg';
import LightBox from './Lightbox';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <LightBox />
      </header>
    </div>
  );
}

export default App;
